import { exec } from "jadelet"
export default exec(["tool",{"class":[{"bind":"instrumentClass"},{"bind":"active"}],"click":{"bind":"click"}},[]])